import { useContext, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../app/hooks"
import { SectionDeleteContext } from "../../DocumentContent"
import { docActionsSelectors, isDocEditable, sectionSelectors, selectDocument } from "../../documentSlice"
import { impossible } from "../../../../app/Utils"
import { APIError } from "../../../../app/appTypes"
import { updateDocSection } from "../../documentsApi"
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, IconButton, TextField, Typography } from "@mui/material"
import { ServerErrorMsg } from "../../../../app/ServerErrorMsg"
import { Localized } from "@fluent/react"
import { If } from "../../../../app/If"
import { LoadingButton } from "@mui/lab"
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import { showError } from "../../../notifications/notificationsSlice"
import { ValidatedObjectSectionView } from "./ValidatedObjectSectionView"

export const ValidatedObjectSectionWrapper = (props: { sectionId: string }) => {
    const { sectionId } = props
    const dispatch = useAppDispatch()
    const deleteSection = useContext(SectionDeleteContext)
    const section = useAppSelector(state => sectionSelectors.selectById(state, sectionId)) ?? impossible()
    const actions = useAppSelector(docActionsSelectors.selectAll) ?? impossible()
    const isEditable = useAppSelector(isDocEditable)

    const { numeration } = section

    const [isEditingTitle, setIsEditingTitle] = useState(false);
    const [tempTitle, setTempTitle] = useState(section.name);
    const [isHovered, setIsHovered] = useState(false);
    const [error, setError] = useState<APIError | null>(null)
    const [del, setDel] = useState(false)
    const [deleting, setDeleting] = useState(false)

    const handleTitleClick = () => {
        setIsEditingTitle(true);
        setTempTitle(section.name);
    };

    const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTempTitle(event.target.value);
    };

    const handleApprove = async () => {
        if (tempTitle) {
            try {
                await dispatch(updateDocSection({ ...section, name: tempTitle })).unwrap()
                setIsEditingTitle(false);
            } catch (error) {
                setError(error as APIError)
            }
        }
    };

    const handleCancel = () => {
        setIsEditingTitle(false);
    };

    const handleDeleteClick = () => setDel(true)

    const handleConfirmDeleteClick = async () => {
        try {
            setDeleting(true)
            deleteSection(sectionId)
        } catch (error) {
            dispatch(showError('error'))
        } finally {
            setDeleting(false)
        }
    }
    const handleCancelDelClick = () => setDel(false)

    return (
        <>
            <Box display="flex" alignItems="center" gap={1} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
                <ServerErrorMsg err={error} />
                <Typography variant="h5" color="primary">
                    {numeration}.
                </Typography>
                {isEditingTitle ? (
                    <>
                        <TextField
                            value={tempTitle}
                            onChange={handleTitleChange}
                            autoFocus
                            variant="standard"
                            fullWidth
                        />
                        <IconButton color="success" onClick={handleApprove}>
                            <CheckIcon />
                        </IconButton>
                        <IconButton color="error" onClick={handleCancel}>
                            <CloseIcon />
                        </IconButton>
                    </>
                ) : (
                    <Box display="flex" alignItems="center" gap={1} sx={{ cursor: 'pointer' }} onClick={handleTitleClick}>
                        <Typography
                            variant="h5"
                            color="primary"
                            sx={{
                                transition: "0.2s",
                                ...(isHovered && { textDecoration: "underline", color: "secondary.main" })
                            }}
                        >
                            {section.name}
                        </Typography>
                        {isHovered && (
                            <>
                                <IconButton size="small" color="primary">
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            </>
                        )}
                    </Box>
                )}
                {isEditable && <Button onClick={handleDeleteClick} color='error' variant='outlined' startIcon={<DeleteIcon />} sx={{ ml: 'auto' }} size='small'>
                    <Localized id='delete'>Usuń</Localized>
                </Button>}
            </Box>
            <Box>
                <ValidatedObjectSectionView
                    documentId={section?.documentId}
                    actions={actions}
                    enablePreview={true}
                    sectionId={sectionId}
                />

            </Box>
            <Dialog open={del}>
                <DialogContent sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}>
                    <If condition={section.subSectionsIds.length > 0}>
                        <Alert severity='warning' variant='standard'>
                            <Localized id='document-delete-section-warning'>_Podsekcje zostaną również usunięte</Localized>
                        </Alert>
                    </If>
                    <DialogContentText>
                        <Localized id="confirm-delete">
                            <span>_Czy napewno chcesz usunąć?</span>
                        </Localized>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={deleting} onClick={handleConfirmDeleteClick}>
                        <Localized id="yes"><span>_Tak</span></Localized>
                    </LoadingButton>
                    <LoadingButton loading={deleting} onClick={handleCancelDelClick}>
                        <Localized id="no"><span>_Nie</span></Localized>
                    </LoadingButton>
                </DialogActions>
            </Dialog>

        </>
    );
}
